interface IProps {
  titre?: string;
  titreClass?: string;
  donnees?: string[] | number[];
  libelles?: string[] | number[];
  elem?: JSX.Element;
  prefixe?: string;
  suffixe?: string;
}

const RowDetailListLibelle: React.FC<IProps> = ({
  titre,
  donnees,
  libelles,
  prefixe = "",
  suffixe = "",
  elem,
  titreClass,
}: IProps) => {
  const N = (a : any) => a === null ? "" : a;

  return (
    <>
    <div className="row">
      <div className={`col-4 ${titreClass ? titreClass : "pae-detail-label"}`} style={{ textAlign: 'left' }}>
        <b>{titre}</b>
      </div>
    </div>
<div className="row">
<div className="col-4" style={{ textAlign: 'left' }}>
    {libelles?.map((item, index) => (
      <div key={index} style={{ marginBottom: '5px' }}>
        {elem ? elem : donnees ? N(prefixe) + item + N(suffixe) : "_"} : 
      </div>
    ))}
  </div>
      <div className="col-8" style={{ textAlign: 'left' }}>
    {donnees?.map((item, index) => (
      <div key={index} style={{ marginBottom: '5px' }}>
        <i>{elem ? elem : donnees ? N(prefixe) + item + N(suffixe) : "_"}</i>
      </div>
    ))}
  </div>
</div>
     
    </>
    
    
  )
};

export default RowDetailListLibelle;
